import React from "react";
import "./HealthBanner.css";
import { motion } from "framer-motion";
import bgImage from "../../Assets/health/Group (1).jpg";

const HealthBanner = () => {
  return (
    <section className="health-banner">
      {/* Blur Scale Reveal */}
      <motion.div
        className="blur-overlay"
        initial={{ scale: 1.2, opacity: 1, filter: "blur(12px)" }}
        animate={{ scale: 1, opacity: 0, filter: "blur(0px)" }}
        transition={{ duration: 2, ease: "easeOut" }}
      ></motion.div>

      <img src={bgImage} alt="Background" className="bg-image" />

      <div className="banner-content">
        <motion.div
          className="left-content"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
        >
          <motion.div
            className="text-box glow"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.5, duration: 1 }}
          >
            <h2>
              At our <span>Medical Center, We Heal with Heart</span>
              <br />
              and a Purpose
            </h2>
            <p>
              At VCNR Healthcare, we believe every life deserves care that is
              both kind and groundbreaking. From rural clinics to specialized
              treatments, we bring care closer to every Indian's heart.
            </p>
            <button
              className="explore-btn1"
              onClick={() =>
                window.open("https://www.hithachinthana.org", "_blank")
              }
            >
              Explore Hospital
            </button>
          </motion.div>
        </motion.div>

        <motion.div
          className="right-content"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1.7, duration: 1.2, ease: "easeOut" }}
        ></motion.div>
      </div>
    </section>
  );
};

export default HealthBanner;
